import "./App.css";
import MyReactComponent from "./MyReactComponent";
import React from "react";
function App() {
  return (
    <div>
      <MyReactComponent />
    </div>
  );
}

export default App;
